module.exports = __webpack_public_path__ + "img/clock.54b05ccb.svg";